import { render, staticRenderFns } from "./PlayIcon.vue?vue&type=template&id=4940c512&scoped=true&"
import script from "./PlayIcon.vue?vue&type=script&lang=js&"
export * from "./PlayIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4940c512",
  null
  
)

export default component.exports